export const BaseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

export const CategoriesRoute = "category";

export const AuthRoute = "auth";

export const BudgetRoute = "budget";
export const ExpensesRoute = "expenses";
